const translations = {
  "meta_title": "What Is ItaobuySpreadsheet? The Ultimate Product Sourcing System (2026 Guide)",
  "meta_description": "Discover how ItaobuySpreadsheet helps e-commerce sellers streamline product research, compare suppliers, and scale their business with a structured, data-driven spreadsheet system.",
  "h1_line1": "What Is ItaobuySpreadsheet?",
  "h1_line2": "The 2026 Sourcing Guide",
  "meta_info": "By Itaobuy Team · Updated June 2026",
  "intro_label": "Introduction",
  "intro_title_line1": "The Complete Guide to",
  "intro_title_line2": "ItaobuySpreadsheet",
  "intro_title_line3": "Product Sourcing",
  "intro_text": "In today's competitive e-commerce landscape, efficient product sourcing can make or break your business. ItaobuySpreadsheet is a structured, spreadsheet-based system designed to help sellers find, compare, and scale winning products faster than ever before. This comprehensive guide covers everything you need to know about using ItaobuySpreadsheet to transform your sourcing workflow.",
  "quote": "Product sourcing doesn't have to be chaotic. ItaobuySpreadsheet gives you a clear, repeatable system that turns hours of manual research into minutes of structured analysis.",
  "author": "Marcus Chen",
  "role": "E-commerce Entrepreneur",
  "benefits_label": "Key Benefits",
  "benefits_title": "Why Sellers Need This Structured System",
  "benefits_subtitle": "Three core advantages that set ItaobuySpreadsheet apart from traditional sourcing methods.",
  "benefit_cards": [
    {
      "title": "Centralized Product Tracking",
      "desc": "Keep all your product data — pricing, suppliers, shipping costs, and profit calculations — organized in a single, logical spreadsheet structure. No more hunting through scattered files or lost information. ItaobuySpreadsheet's intuitive layout ensures every piece of sourcing data is exactly where you expect it to be, saving hours of search time every week."
    },
    {
      "title": "Instant Supplier Comparison",
      "desc": "Compare multiple suppliers side by side with pre-configured comparison fields. Evaluate pricing structures, minimum order quantities, shipping timelines, and quality indicators all in one view. This systematic approach to supplier comparison helps you identify the best deals and avoid costly mistakes that eat into your profit margins."
    },
    {
      "title": "Scalable Workflow Design",
      "desc": "Whether you're managing 50 products or 5,000, ItaobuySpreadsheet scales with your business. The automation-friendly format integrates seamlessly with your existing tools, while the structured data layout makes it easy to spot trends, identify winning categories, and make data-driven scaling decisions with confidence."
    }
  ],
  "cta_title": "GET THE FULL SPREADSHEET",
  "cta_subtitle_line1": "Ready to transform your product sourcing?",
  "cta_subtitle_line2": "Access ItaobuySpreadsheet and start scaling today.",
  "cta_button": "ACCESS ITAOBUY SHEET NOW",
  "back_to_home": "← Back to Home",
  "footer": {
    "copyright": "© 2026 itaobuy.boats. All rights reserved.",
    "back_home": "Back to Home"
  }
};

export default translations;